/*
 * Copyright (C) CEDE Labs, SAS - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by CEDE Labs team <team@cedelabs.io>, September 2021
 */
import Loader from "react-loader-spinner";

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

export const SpinnerLoader = ({ width = 100, height = 100 }: Props) => (
  <Loader
    type="Rings"
    color="#11A49A"
    height={height}
    width={width}
    timeout={60000} //1 min
  />
);

export const OvalLoader = ({ height = 80, width = 80, color = "#11A49A" }: Props) => (
  <div className="inline-flex">
    <Loader type="Oval" height={height} width={width} color={color} />
  </div>
);
